import { Component, OnInit } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { RecommendationModel } from 'projects/core/src/lib/models/recommendation.model';
import { Router, ActivatedRoute } from '@angular/router';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { HelperService } from 'projects/admin/src/app/services/helper.service';

@Component({
  selector: 'app-recommendation-detail',
  templateUrl: './recommendation-detail.component.html',
  styleUrls: ['./recommendation-detail.component.scss']
})
export class RecommendationDetailComponent extends BaseDetail implements OnInit {

  public recommendation: RecommendationModel = null;
  public backRoute = ['/recommendations'];

  protected identifier = 'recommendation';

  constructor(
    protected ui: UiService,
    protected router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    protected helper: HelperService,
    public transloco: TranslocoService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        this.api.getModel('recommendations', params.id).subscribe({
          next: (result: any) => {
            this.recommendation = new RecommendationModel().deserialize(result.data);
            this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab'), 10);
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

}
